import { createElement, memo } from '@max/max';
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import SlideModal from '@max/leez-slide-modal';
import View from '@hfe/max-view';
// import { screenHeight, statusBarHeight } from '../until';
import './index.scss';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
import LImage from '@max/leez-image';
import { rpx2px } from '@hfe/max-universal-unit-tool';
function LightUpCityShareModal(p) {
    const ctx = useMonitorEngineContext();
    const { lightCityInfo, onShare, onClose, visible, onBack } = p;
    return <View>
      <SlideModal visible={visible} showHeader={false} showCloseBtn={false} maskClosable={true} addBottomSpace={false} 
    // modalMaxHeight={rpx2px(898)}
    contentStyle={{
        margin: 0,
        paddingLeft: 0,
        paddingRight: 0,
        padding: 0
    }} onClosePress={onClose}>
        <LImage className="light-up-city-share-main" source={{
        uri: "https://p0.meituan.net/ingee/a009376871e9f51a728dd455ea9ca35e9229.png"
    }} width={rpx2px(750)} height={rpx2px(670)}>
          <View style={{
        position: 'relative',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
            <LImage source={{
        uri: "https://img.meituan.net/makerjiulv/3d99f251ce59386aa0fa38a34208fbc98095.png"
    }} style={{
        width: "610rpx",
        height: '72rpx',
        marginTop: '29rpx'
    }}/>
            <LImage source={{
        uri: 'https://img.meituan.net/makerjiulv/e18359a5f095559a508718be72c2b0301324.png'
    }} style={{
        width: '44rpx',
        height: '44rpx',
        position: 'absolute',
        right: '20rpx',
        top: '15rpx'
    }} onPress={onClose}/>
          </View>
          <Text className="light-up-city-share-head-tips">下单成功后可解锁抽免单资格</Text>
          <View className="light-up-city-content">
              <Text className="light-up-city-content-city-content-tips">你的心愿城市</Text>
              <Text className="light-up-city-content-city-name">{lightCityInfo === null || lightCityInfo === void 0 ? void 0 : lightCityInfo.cityName}</Text>
          </View>
          <View className='light-up-city-share-buttons'>
            <Button className='light-up-city-share-back-btn' onPress={onBack}>
              <Text className="light-up-city-share-back-btn-text">返回上一步</Text>
            </Button>
            <View className="light-up-city-share-button-wrap">
              <Button onPress={() => onShare(lightCityInfo)}>
                <LImage source={{
        uri: 'https://p0.meituan.net/ingee/3df8b5f1d8dae51e0fbc86229ccb91fa23667.png'
    }} style={{
        width: '393rpx',
        height: '90rpx'
    }}/>
              </Button>
              <View className="light-up-city-share-button-tips">
                <Text className="light-up-city-share-button-tips-text">分享将消耗1次机会</Text>
              </View>
            </View>
          </View>
          
        </LImage>
      </SlideModal>
    </View>;
}
export default memo(LightUpCityShareModal);
